module.exports = "/6/0-mang-ki-tu/index.html.c07e54b9b2919b7ae2f406f37d0fbed3.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30090.md
 ** module id = 557
 ** module chunks = 0
 **/